"use client";

import { useEffect } from "react";

import { useSetInitialDiscountState } from "~/components/providers/initial-discount-provider";

export function DiscountHydrationBridge({
  initialDiscountCode,
}: {
  initialDiscountCode: string | null;
}) {
  const setInitialDiscountState = useSetInitialDiscountState();

  useEffect(() => {
    setInitialDiscountState({
      code: initialDiscountCode,
      isHydrated: true,
    });
  }, [initialDiscountCode, setInitialDiscountState]);

  return null;
}
